module.exports = __webpack_public_path__ + "assets/images/441e86dac0fa80166e998541f27f1506.png";